(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[185],{

/***/ 1185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CarrierListI18nEnum": function() { return /* binding */ CarrierListI18nEnum; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7135);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9072);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9970);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5767);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9496);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3751);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9167);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _carrierList_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(8995);
/* harmony import */ var _carrierList_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_carrierList_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var antd_mobile__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8179);
/* harmony import */ var _src_utils_useXState__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2517);
/* harmony import */ var _src_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7817);
/* harmony import */ var _IconSvg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7143);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6131);














var CarrierListI18nEnum = [
    "ResGCountry",
    "ResGCompYQInput",
    "ResUnimPTrack",
    "ResGExpressGroup",
    "ResUnimPCarrierList",
    "ResUnimPCarrierSelect"
];
var CarrierList = function(props) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var query = router.query, locale = router.locale;
    var $t = props.$t;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), carrierList = ref[0], setCarrierList = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), page = ref1[0], setPage = ref1[1];
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_src_utils_useXState__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        visible: false,
        historyList: [],
        inputVal: "",
        // carrierList: React.$carrier?.carrierList || [],
        showList: [],
        hasMore: false,
        // page: 0,
        pageSize: 20
    }), 2), state = ref2[0], updateState = ref2[1];
    var ResGCountryDict = $t("ResGCountry").items.itemsDict;
    var onBack = function() {
        props.beforClose && props.beforClose();
        next_router__WEBPACK_IMPORTED_MODULE_3___default().back();
    };
    var onSearch = _src_utils__WEBPACK_IMPORTED_MODULE_6__/* ["default"].func.debounce */ .ZP.func.debounce(function(str) {
        var val = str.trim();
        var result = val ? react__WEBPACK_IMPORTED_MODULE_1__.$carrier.searchCarrier(val) : react__WEBPACK_IMPORTED_MODULE_1__.$carrier.carrierList;
        initData(result);
    }, 200);
    function loadMore() {
        return _loadMore.apply(this, arguments);
    }
    function _loadMore() {
        _loadMore = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
            var pages, pageSize, start, end, newData, showList;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                pages = page + 1;
                pageSize = state.pageSize;
                start = pages * pageSize;
                end = start + pageSize;
                newData = carrierList.slice(start, end);
                showList = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(state.showList.concat(newData));
                setPage(pages);
                updateState("showList", showList, function() {
                    hasMoreByLength(newData.length);
                });
                return [
                    2
                ];
            });
        });
        return _loadMore.apply(this, arguments);
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        react__WEBPACK_IMPORTED_MODULE_1__.$carrier.updateCarrier($t);
        initData(((ref = react__WEBPACK_IMPORTED_MODULE_1__.$carrier) === null || ref === void 0 ? void 0 : ref.carrierList) || []);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (props.show && props.showAuto) initHistory();
    }, [
        props.show
    ]);
    var initHistory = function() {
        var keys = getHistory();
        var historyArr = [];
        keys.forEach(function(key) {
            var info = react__WEBPACK_IMPORTED_MODULE_1__.$carrier.getCarrier(key);
            if (info) {
                historyArr.push(info);
            }
        });
        updateState("historyList", (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(historyArr));
    };
    var getHistory = function(carrierKey) {
        var history = "";
        try {
            history = js_cookie__WEBPACK_IMPORTED_MODULE_8__/* ["default"].get */ .Z.get("v5_HisExpress") || "";
        } catch (e) {
            ;
        }
        if (carrierKey) {
            history = carrierKey + "_" + history;
        }
        return history ? Array.from(new Set(history.split("_").map(function(i) {
            return Number(i);
        }))) : [];
    };
    var setHistory = function(carrierKey) {
        if (!carrierKey || carrierKey === "0") {
            return;
        }
        var historyArr = getHistory(carrierKey);
        historyArr = historyArr.filter(function(value) {
            return value != 0;
        });
        var result = historyArr.slice(0, 8);
        //#ifdef H5
        //保存cookie;
        js_cookie__WEBPACK_IMPORTED_MODULE_8__/* ["default"].set */ .Z.set("v5_HisExpress", result.join("_"), {
            expires: 365,
            path: "/",
            domain: "17track.net"
        });
    };
    var initData = function(allList) {
        setPage(0);
        var pageData = allList.slice(0, state.pageSize);
        setCarrierList(allList);
        updateState("showList", (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(pageData), function() {
            hasMoreByLength(pageData.length);
        });
    };
    var hasMoreByLength = function(length) {
        updateState("hasMore", length >= state.pageSize);
    };
    var renderCounntry = function(item) {
        var keys = item._country_iso || "0";
        var countryObj = ResGCountryDict.get(keys);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
            className: (_carrierList_module_scss__WEBPACK_IMPORTED_MODULE_13___default().nameBox),
            children: countryObj._name
        });
    };
    var onClickCarrier = function(item) {
        if (query.carrierType) {
            // router.back()
            setHistory(item.key);
            props.onClickCarrier && props.onClickCarrier(item, query.carrierType || "fc");
        } else {
            window.open(item._url);
        }
    };
    var showName = function(item) {
        return item["_name_" + locale] || item._name;
    };
    var onClickAuto = function() {
        props.autoClick && props.autoClick();
    };
    var renderText = function(item) {
        if (item._country_iso) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    renderCounntry(item),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: (_carrierList_module_scss__WEBPACK_IMPORTED_MODULE_13___default().countryTitle),
                        children: showName(item)
                    })
                ]
            });
        } else {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_carrierList_module_scss__WEBPACK_IMPORTED_MODULE_13___default().nameBox),
                children: showName(item)
            });
        }
    };
    var showDefaultImg = function(e) {
        if (e.target) {
            e.target.src = "//res.17track.net/asset/carrier/logo/34x34/0.png";
        }
    };
    var renderItem = function(item, index) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_carrierList_module_scss__WEBPACK_IMPORTED_MODULE_13___default().itemBox),
            id: "CarrierListItemBox-".concat(index),
            onClick: function() {
                onClickCarrier(item);
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_carrierList_module_scss__WEBPACK_IMPORTED_MODULE_13___default().imgIcon),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_carrierList_module_scss__WEBPACK_IMPORTED_MODULE_13___default().img),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: "https://res.17track.net/asset/carrier/logo/120x120/".concat(item.key, ".png"),
                            onError: function(e) {
                                showDefaultImg(e);
                            },
                            alt: item._name,
                            layout: "fill"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_carrierList_module_scss__WEBPACK_IMPORTED_MODULE_13___default().infoBox),
                    children: renderText(item)
                })
            ]
        }, item.key);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_carrierList_module_scss__WEBPACK_IMPORTED_MODULE_13___default().container),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_carrierList_module_scss__WEBPACK_IMPORTED_MODULE_13___default().topBox),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_4__/* .NavBar */ .l2, {
                        onBack: onBack,
                        className: (_carrierList_module_scss__WEBPACK_IMPORTED_MODULE_13___default().topHeadNav),
                        children: props.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_carrierList_module_scss__WEBPACK_IMPORTED_MODULE_13___default().searchBox),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_4__/* .SearchBar */ .E1, {
                            placeholder: $t("ResUnimPCarrierList.global.__search_placeholder"),
                            value: state.inputVal,
                            onChange: function(val) {
                                updateState("inputVal", val);
                                onSearch(val);
                            },
                            onSearch: function(val) {
                                onSearch(val);
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_carrierList_module_scss__WEBPACK_IMPORTED_MODULE_13___default().mainBox),
                children: [
                    props.showAuto && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_carrierList_module_scss__WEBPACK_IMPORTED_MODULE_13___default().autoBox),
                        id: "CarrierListAutoBox",
                        onClick: function() {
                            onClickAuto();
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_IconSvg__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                src: "/asset/icons/autoBtn.svg",
                                class: (_carrierList_module_scss__WEBPACK_IMPORTED_MODULE_13___default().iconBox)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: (_carrierList_module_scss__WEBPACK_IMPORTED_MODULE_13___default().autoText),
                                children: $t("ResGCompYQInput.global.__dialogCarrier_autoTitle")
                            })
                        ]
                    }),
                    !state.inputVal && state.historyList && state.historyList.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_carrierList_module_scss__WEBPACK_IMPORTED_MODULE_13___default().historyBox),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_carrierList_module_scss__WEBPACK_IMPORTED_MODULE_13___default().titleBox),
                                children: $t("ResUnimPCarrierSelect.global.__history_title")
                            }),
                            state.historyList.map(function(item, index) {
                                return renderItem(item, index);
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_carrierList_module_scss__WEBPACK_IMPORTED_MODULE_13___default().listBox),
                        children: [
                            state.showList && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    state.historyList && state.historyList.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_carrierList_module_scss__WEBPACK_IMPORTED_MODULE_13___default().titleBox),
                                        children: $t("ResUnimPCarrierList.global.__title")
                                    }),
                                    state.showList.map(function(item, index) {
                                        return renderItem(item, index);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_4__/* .InfiniteScroll */ .v_, {
                                loadMore: loadMore,
                                hasMore: state.hasMore,
                                children: state.hasMore ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_4__/* .DotLoading */ .k_, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        "~ ",
                                        $t("ResUnimPTrack.global.__noMoreUpdates"),
                                        " ~"
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (CarrierList);


/***/ }),

/***/ 8995:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"carrierList_container__JInpH","topBox":"carrierList_topBox__JDHuj","topHeadNav":"carrierList_topHeadNav__nw_2B","searchBox":"carrierList_searchBox__rtkl8","mainBox":"carrierList_mainBox__TYIJm","autoBox":"carrierList_autoBox__0OgPL","iconBox":"carrierList_iconBox__qYGmH","autoText":"carrierList_autoText__wqqBo","titleBox":"carrierList_titleBox__JlsXh","historyBox":"carrierList_historyBox__xN_ui","listBox":"carrierList_listBox__6cBF4","itemBox":"carrierList_itemBox___7m93","imgIcon":"carrierList_imgIcon__X8IaU","img":"carrierList_img__P4n_q","infoBox":"carrierList_infoBox__25BFW","nameBox":"carrierList_nameBox__4HiiL","countryTitle":"carrierList_countryTitle__r_aJV"};

/***/ })

}]);